import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DigitalBadgeEntryDisplayModel } from 'src/model/VideoCourses/DigitalBadgeEntryDisplayModel';
import { CoursewareService } from 'src/services/CoursewareService';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Breadcrumb } from 'src/model/Breadcrumb';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { globals } from '../shared/globals';
import { EmbedVideoService } from 'ngx-embed-video';
import { MetaService } from 'src/services/MetaService';
import { TextUtils } from '../shared/textutil';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-videocoursemodule',
  templateUrl: './videocoursemodule.component.html',
  styleUrls: ['./videocoursemodule.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class VideocoursemoduleComponent extends BaseComponent implements OnInit, OnDestroy {
  modulecontent: DigitalBadgeEntryDisplayModel;
  public breadcrumbs: Breadcrumb[] = [];
  public timeindex: string;
  theVideoUrl: any;
  public textPart1: string;
  public textPart2: string;
  alias = null;
  errorMessage: string;

  constructor(private canonicalService: MetaService, private embedService: EmbedVideoService, private titleService: Title, private _router: Router, private route: ActivatedRoute, private coursewareService: CoursewareService, private alertService: AlertService) {
    super();
  }

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }

  ngOnInit() {
    this.alias = this.route.snapshot.paramMap.get('alias');
    let parent = this.route.snapshot.paramMap.get('parent');
    this.timeindex = this.route.snapshot.paramMap.get('timeindex');

    if (!this.timeindex) {
      this.timeindex = this.route.snapshot.queryParams.TimeIndex;
    }

    this.coursewareService.getVideocoursesModule(this.alias, parent).subscribe(data => {
      this.modulecontent = data;
      if (!this.modulecontent.Entry) {
        this.modulecontent = null;
        let error: Error = data;
        this.alertService.error(error.Message);
        return;
      }
      let textUtils = new TextUtils(this.modulecontent.Entry.Html);
      this.textPart1 = textUtils.firstHalf;
      this.textPart2 = textUtils.secondHalf;

      let theUrl = globals.LOCALHOST + this._router.url + "/";

      this.getTheVideoUrl();

      let shortenedTitle = this.modulecontent.Title;
      if (shortenedTitle) {
        const whereToEndTitle = this.modulecontent.Title.indexOf("- Module");
        if (whereToEndTitle > 0)
          shortenedTitle = shortenedTitle.substring(0, whereToEndTitle - 1);
      }

      this.canonicalService.addMetaTags(theUrl, this.modulecontent.Summary, this.modulecontent.LogoUrl, shortenedTitle, this.modulecontent.FacebookAppId);

      this.titleService.setTitle(shortenedTitle);

      this.breadcrumbs = [{ Title: "Video-Courses", URL: "/videocoursesview" }, { Title: this.modulecontent.DigitalBadgeCourse.Information.Title, URL: "/videocoursescontentview/" + this.modulecontent.DigitalBadgeCourse.Information.Alias }, { Title: this.modulecontent.Entry.ContentEntryDescriptor.Information.Title, URL: "/videocoursesview/" + this.modulecontent.Entry.ContentEntryDescriptor.Information.Alias }];
      this.canonicalService.createCanonicalURL(this._router.url, "/videocoursesmoduleview/" + this.modulecontent.Entry.ContentEntryDescriptor.Information.Alias);
      this.pushAllAds(3);
    }, error => this.errorMessage = error);
  }

  getTheHtml() {
    return this.modulecontent.Entry.Html;
  }

  public getTheVideoUrl() {
    let timeindexstring = "";
    if (this.timeindex) {
      let totalseconds = Number(this.timeindex);
      if (totalseconds > 0) {
        let minutes = Math.floor(totalseconds / 60);
        let seconds = Math.floor(totalseconds % 60);
        timeindexstring = "#t=" + minutes + "m" + seconds + "s";
      }
    }

    this.theVideoUrl = this.embedService.embed_vimeo(this.modulecontent.Entry.VendorVideoID + timeindexstring);
  }
}